import { commonTypes } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/formSchema";

export const isPlannedInfraStructureEvent = (type: string) =>
  type === "INFRASTRUCTURE_PLANNED_MAINTENANCE";

type CommonType = (typeof commonTypes)[number];
export const isCommonInfraStructureEvent = (type: string) =>
  commonTypes.includes(type as CommonType);

export const isInfrastructureStretchPartiallyClosedEvent = (type: string) =>
  type === "INFRASTRUCTURE_STRETCH_PARTIALLY_CLOSED";

export const isInfrastructureStretchClosedEvent = (type: string) =>
  type === "INFRASTRUCTURE_STRETCH_CLOSED";

// Intentionally only accepts the whole event. As the check varies from response/form/request
export const isCustomInfraStructureEvent = (type: string | undefined) =>
  type?.includes("INFRASTRUCTURE_GENERAL");
